import { Routes } from '@angular/router';
import { InviteRoutes } from './invite/invite.routes';
import { AccountBaseComponent } from './account-base.component';
import { personalInformationRoutes } from './personal-information/personal-information.routes';
import { insuranceRoutes } from './insurance/insurance.routes';
import { connectedAccountsRoutes } from './connected-accounts/connected-accounts.routes';
import { subscriptionRoutes } from './subscriptions/subscription.routes';

export const accountRoutes: Routes = [
  {
    path: '',
    loadComponent: () => import('./chose-account/chose-account.page').then((m) => m.ChoseAccountPage),
  },
  {
    path: 'add',
    loadComponent: () => import('./invite/invite.page').then((m) => m.InvitePage),
    children: InviteRoutes,
  },
  {
    path: ':id',
    component: AccountBaseComponent,
    children: [
      {
        path: '',
        loadComponent: () => import('./account-options/account-options.page').then((m) => m.AccountOptionsPage),
      },
      {
        path: 'personal-information',
        loadComponent: () =>
          import('./personal-information/personal-information.page').then((m) => m.PersonalInformationPage),
        children: personalInformationRoutes,
      },
      {
        path: 'insurance',
        loadComponent: () => import('./insurance/insurance.page').then((m) => m.InsurancePage),
        children: insuranceRoutes,
      },
      {
        path: 'pharmacy',
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./preferred-pharmacy/preferred-pharmacy.page').then((m) => m.PreferredPharmacyPage),
          },
          {
            path: 'search',
            loadComponent: () =>
              import(
                './preferred-pharmacy/pharmacy-search/account-pharmacy-search/account-pharmacy-search.component'
              ).then((m) => m.AccountPharmacySearchComponent),
          },
          {
            path: 'preview',
            loadComponent: () =>
              import(
                './preferred-pharmacy/pharmacy-preview/account-pharmacy-preview/account-pharmacy-preview.component'
              ).then((m) => m.AccountPharmacyPreviewComponent),
          },
        ],
      },
      {
        path: 'subscriptions',
        children: subscriptionRoutes,
      },
      {
        path: 'connected',
        loadComponent: () =>
          import('./connected-accounts/connected-accounts.page').then((m) => m.ConnectedAccountsPage),
        children: connectedAccountsRoutes,
      },
      {
        path: 'contact-information',
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./contact-information/contact-information.component').then((m) => m.ContactInformationComponent),
          },
          {
            path: 'review-contact-info',
            loadComponent: () =>
              import('./contact-information/review-contact-info/review-contact-info.component').then(
                (m) => m.ReviewContactInfoComponent,
              ),
          },
          {
            path: 'review-address-info',
            loadComponent: () =>
              import('./contact-information/review-address-info/review-address-info.component').then(
                (m) => m.ReviewAddressInfoComponent,
              ),
          },
          {
            path: 'verify-contact-info',
            loadComponent: () =>
              import('./contact-information/verify-contact-info/verify-contact-info.component').then(
                (m) => m.VerifyContactInfoComponent,
              ),
          },
          {
            path: 'confirm-contact-info',
            loadComponent: () =>
              import('./contact-information/confirm-contact-info/confirm-contact-info.component').then(
                (m) => m.ConfirmContactInfoComponent,
              ),
          },
          {
            path: 'address-contact-info',
            loadComponent: () =>
              import('./contact-information/address-contact-info/address-contact-info.component').then(
                (m) => m.AddressContactInfoComponent,
              ),
          },
          {
            path: ':type',
            loadComponent: () =>
              import('./contact-information/update-contact-info/update-contact-info.component').then(
                (m) => m.UpdateContactInfoComponent,
              ),
          },
        ],
      },
      {
        path: 'medications',
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./health-summary/medications/medications.component').then((m) => m.MedicationsComponent),
          },
        ],
      },
      {
        path: 'medical-history',
        loadComponent: () =>
          import('./health-summary/medical-history/medical-history.component').then((m) => m.MedicalHistoryComponent),
      },
      {
        path: 'lab-results',
        loadComponent: () =>
          import('./health-summary/lab-results/lab-results.component').then((m) => m.LabResultsComponent),
      },
      {
        path: 'documents',
        loadComponent: () => import('./health-summary/documents/documents.component').then((m) => m.DocumentsComponent),
      },
    ],
  },
];
